import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './breadcrumb.component';
import { RouterModule } from '@angular/router';
import {HeaderModule} from '../header/header.module';
import { ModalModule } from '../modal/modal.module';
import { QuickFilterRecommendationHeaderComponent } from '../quick-filter-recommendation-header/quick-filter-recommendation-header.component';
import { ItemPricingInventoryHealthChipModule } from '../../forecastui/item-pricing-inventory-health-chip/item-pricing-inventory-health-chip.module';
import { ActionCenterManualSuggestionComponent } from '../action-center-manual-suggestion/action-center-manual-suggestion.component';
import { ProductAdsHistoryLogModule } from '../product-ads-history-log/product-ads-history-log.module';
import { BulkHistoryModule } from '../bulk-history/bulk-history.module';
import { NgbCollapseModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ProductAdsBulkReviewModalModule } from 'src/app/routes/dashboard/amz-advertising/campaign-product-ads/product-ads-bulk-review-modal/product-ads-bulk-review-modal.module';
import { AlertProductAdsHistoryLogsComponent } from '../alert-product-ads-history-logs/alert-product-ads-history-logs.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HeaderModule,
    ModalModule,
    ItemPricingInventoryHealthChipModule,
    NgbCollapseModule,
    NgbTooltipModule,
    ProductAdsHistoryLogModule,
    ProductAdsBulkReviewModalModule,
    BulkHistoryModule
  ],
  declarations: [
    AlertProductAdsHistoryLogsComponent,
    BreadcrumbComponent, 
    QuickFilterRecommendationHeaderComponent,
    ActionCenterManualSuggestionComponent
  ],
  exports: [
    BreadcrumbComponent, 
    AlertProductAdsHistoryLogsComponent
  ],
})
export class BreadcrumbModule { }
